export const getColor = (status) => {
  switch (status) {
    case "Full Time":
      return "#FF8A00";
    case "Internship":
      return "blue";
    case "Remote":
      return "#56E5C4";
    default:
      return "#FF8A00";
  }
};
